<template>
  <div
    class="Polaris-Page p-6"
    :class="{ 'Polaris-Page--fullWidth': isFullWidth }"
  >
    <div
      class="Polaris-Box"
      style="--pc-box-padding-block-end-xs:var(--p-space-4);--pc-box-padding-block-end-md:var(--p-space-5);--pc-box-padding-block-start-xs:var(--p-space-4);--pc-box-padding-block-start-md:var(--p-space-5);--pc-box-padding-inline-start-xs:var(--p-space-4);--pc-box-padding-inline-start-sm:var(--p-space-0);--pc-box-padding-inline-end-xs:var(--p-space-4);--pc-box-padding-inline-end-sm:var(--p-space-0);position:relative"
    >
      <div
        class="Polaris-Page-Header--noBreadcrumbs Polaris-Page-Header--mediumTitle"
      >
        <div class="Polaris-Page-Header__Row">
          <div v-if="showBack" class="Polaris-Page-Header__BreadcrumbWrapper">
            <div
              class="Polaris-Box Polaris-Box--printHidden"
              style="--pc-box-max-width:100%;--pc-box-padding-inline-end-xs:var(--p-space-4)"
            >
              <nav role="navigation">
                <div class="Polaris-Page-Header__BreadcrumbWrapper">
                  <div
                    class="Polaris-Box Polaris-Box--printHidden"
                    style="--pc-box-max-width:100%;--pc-box-padding-inline-end-xs:var(--p-space-100)"
                  >
                    <a
                      class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantSecondary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter Polaris-Button--iconOnly"
                      aria-label="Back"
                      href="#"
                      @click="goBack"
                      data-polaris-unstyled="true"
                    >
                      <span class="Polaris-Button__Icon">
                        <span class="Polaris-Icon">
                          <svg
                            viewBox="0 0 20 20"
                            class="Polaris-Icon__Svg"
                            focusable="false"
                            aria-hidden="true"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M16.5 10a.75.75 0 0 1-.75.75h-9.69l2.72 2.72a.75.75 0 0 1-1.06 1.06l-4-4a.75.75 0 0 1 0-1.06l4-4a.75.75 0 1 1 1.06 1.06l-2.72 2.72h9.69a.75.75 0 0 1 .75.75Z"
                            ></path>
                          </svg>
                        </span>
                      </span>
                    </a>
                  </div>
                </div>
              </nav>
            </div>
          </div>
          <div class="Polaris-Page-Header__TitleWrapper">
            <h1 class="Polaris-Header-Title">
              <span
                class="Polaris-Text--root Polaris-Text--headingLg Polaris-Text--bold"
                >{{ title }}</span
              >
            </h1>
          </div>
          <div class="Polaris-Page-Header__RightAlign">
            <div class="Polaris-Page-Header__Actions">
              <slot name="action"></slot>
            </div>
          </div>
        </div>
      </div>

      <div><slot></slot></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isFullWidth: {
      type: Boolean,
      default: false
    },
    title: {
      type: String
    },
    showBack: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style></style>
